import { rootStore } from '../store/Root.store'

export const forceRedirect = (redirectUrl: string) => {
  rootStore.TrackingState.setShouldKeepAlive(false)
  rootStore.InterfaceState.setSendBeforeunloadEvent(false)
  window.location.href = redirectUrl
}

// Like forceRedirect, but the current page is replaced in the history instead of kept behind the
// target: for leaving a page the user must not be able to come back to.
export const forceReplace = (redirectUrl: string) => {
  rootStore.TrackingState.setShouldKeepAlive(false)
  rootStore.InterfaceState.setSendBeforeunloadEvent(false)
  window.location.replace(redirectUrl)
}

export const forceReload = () => {
  rootStore.InterfaceState.setSendBeforeunloadEvent(false)
  window.location.reload()
}

export const addSearchParamsAndReload = (params: Record<string, string>) => {
  const url = new URL(window.location.href)

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(key, value)
  })

  if (window.location.href === url.toString()) {
    window.location.reload()
  } else {
    window.location.href = url.toString()
  }
}
